if (!customElements.get("localization-form")) {
  customElements.define(
    "localization-form",
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector(
            'input[name="locale_code"], input[name="country_code"]',
          ),
          button: this.querySelector("button"),
          panel: this.querySelector(".disclosure__list-wrapper"),
        };
        this.elements.button?.addEventListener(
          "click",
          this.openSelector.bind(this),
        );
        this.elements.button?.addEventListener(
          "focusout",
          this.closeSelector.bind(this),
        );
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

        this.querySelectorAll("a").forEach((item) =>
          item.addEventListener("click", this.onItemClick.bind(this)),
        );
      }

      hidePanel() {
        this.elements.button.setAttribute("aria-expanded", "false");
        this.elements.panel.setAttribute("hidden", true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        if (this.elements.button.getAttribute("aria-expanded") == "false")
          return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
        this.hidePanel();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute("hidden");
        this.elements.button.setAttribute(
          "aria-expanded",
          (
            this.elements.button.getAttribute("aria-expanded") === "false"
          ).toString(),
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) ||
          this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    },
  );
}
// 특정 국가 선택 시 .shop으로 리디렉션
var SHOP_REDIRECT_COUNTRIES = ['KR', 'CN', 'JP'];

document.addEventListener('change', function(e) {
  var form = e.target.closest('form[action="/localization"]');
  if (!form) return;
  
  var countryInput = form.querySelector('[name="country_code"]');
  if (countryInput && SHOP_REDIRECT_COUNTRIES.indexOf(countryInput.value) !== -1) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = 'https://www.seteveryday.shop';
  }
});

document.addEventListener('click', function(e) {
  var option = e.target.closest('[data-value], [data-country]');
  if (!option) return;
  
  var country = option.dataset.value || option.dataset.country;
  if (SHOP_REDIRECT_COUNTRIES.indexOf(country) !== -1) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = 'https://www.seteveryday.shop';
  }
});
